<div class="links-tab left-col-spacer">
  <button
    type="button"
    mat-raised-button
    color="accent"
    class="add-new-link-btn"
    (click)="openNewLinkDialog()"
    trans
  >
    Add New Link
  </button>
  <button
    type="button"
    mat-raised-button
    color="accent"
    class="add-widget-btn"
    (click)="openWidgetListDialog()"
    [matTooltip]="'Add widget' | trans"
  >
    <mat-icon svgIcon="widgets"></mat-icon>
  </button>

  <ng-container *ngIf="editor.biolink$ | async as biolink; else loading">
    <div
      class="link-list"
      cdkDropList
      [cdkDropListDisabled]="editor.loading$ | async"
      (cdkDropListDropped)="reorderContent($event)"
      @fadeIn
    >
      <ng-container  *ngFor="let contentItem of biolink.content; trackBy: trackByFn">
        <biolink-editor-link
          class="biolink-content-item"
          [link]="contentItem"
          *ngIf="contentItem.model_type === 'link'"
          cdkDrag
        ></biolink-editor-link>
        <biolink-editor-widget
          class="biolink-content-item"
          [widget]="contentItem"
          *ngIf="contentItem.model_type === 'biolinkWidget'"
          cdkDrag
        ></biolink-editor-widget>
      </ng-container>

      <no-results-message svgImage="share-link.svg" *ngIf="!biolink.content.length">
        <span primary-text trans>No links or widgets have been added yet</span>
      </no-results-message>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="link-list" @fadeOut>
      <div class="biolink-content-item" *ngFor="let s of skeletonIterator">
        <div class="content-item-wrapper">
          <div class="drag-handle-container">
            <skeleton variant="icon"></skeleton>
          </div>
          <div class="content-item-body">
            <skeleton animation></skeleton>
            <skeleton></skeleton>
            <skeleton></skeleton>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
